<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
          label="姓名"
        >
          <el-input
            v-model="searchForm.name"
            placeholder="姓名"
            style="width: 100px;"
          />
        </el-form-item>
        <el-form-item
                label="电话号码"
        >
          <el-input
                  v-model="searchForm.contact_number"
                  placeholder="电话号码"
                  style="width: 100px;"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
      v-if="multipleSelection.length>0"
      type="danger"
      size="mini"
      icon="el-icon-delete"
      @click="batchDel"
    >
      删除
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="顾客编号"
      >
        <template slot-scope="scope">
          {{scope.row.agentid}}
        </template>
      </el-table-column>

      <el-table-column
        label="姓名"
      >
        <template slot-scope="scope">
          {{scope.row.name}}
        </template>
      </el-table-column>
      <el-table-column
        label="手机号"
      >
        <template slot-scope="scope">
          {{scope.row.contact_number}}
        </template>
      </el-table-column>
      <el-table-column
              label="地址"
              width="200"
      >
        <template slot-scope="scope">
          {{scope.row.province_address}}
        </template>
      </el-table-column>
      <el-table-column
              label="备注"
      >
        <template slot-scope="scope">
          {{scope.row.detail_address}}
        </template>
      </el-table-column>
      <el-table-column
              label="是否默认地址"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.isdefault=='1'">
            默认地址
          </div>

        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <el-button type="primary" plain size="mini"    @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>

  </d2-container>
</template>
<script>
import * as memberService from '@/api/sys/member'
import util from '@/libs/util.js'
export default {
  name: 'MembergglPage',
  components: { },
  data () {
    return {
      searchForm: {
        fxtel: '',
        legal: '',
        userCode: ''
      },
      loading: false,
      tableData: [],
      multipleSelection: [],
      dateRange: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: '',
        order: ''
      },
      oneclass: {},
      agentid: ''
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    dateConversion (value) {
      if (value != null && value != '') {
        var d = new Date(value)
        //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
        var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
        console.info('===========date=========' + date)
        return date
      } else {
        return ''
      }
    },
    getTableData () {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
        dl_type: util.cookies.get('dl_type'),
        xt_id: util.cookies.get('xt_id'),
        agentid: util.cookies.get('agentid'),
        descending: this.sort.order === 'descending',
        filter: this.searchForm
      }
      memberService.getAddressPageList(query).then(data => {
        this.tableData = data.rows
        this.page.total = data.totalCount
      })
    },
    handleSearchFormSubmit () {
      this.getTableData()
    },
    handleSearchFormReset () {
      this.$refs.searchForm.resetFields()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleSortChange (val) {
      this.sort.prop = val.prop
      this.sort.order = val.order
      this.getTableData()
    },
    handleSizeChange (val) {
      this.page.size = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.current = val
      this.getTableData()
    },
    batchDel () {
      this.$confirm('确认删除？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        memberService
          .delAddressBath({
            ids: JSON.stringify(this.multipleSelection.map(s => s.addressId))
          })
          .then(() => {
            this.getTableData()
          })
      })
    },
    del (oneclass) {
      this.$confirm('确认删除？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        memberService.delAddress({ addressId: oneclass.addressId }).then(() => {
          this.getTableData()
        })
      })
    }
  }
}
</script>
